import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { UserService, ObservatoryService, StorageService } from '@services/services.module';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() toggleMiniSideBar = new EventEmitter();
  private subscriptions: Array<Subscription> = [];
  public userData: any;
  miniLogoVisible = false;

  constructor(
    private user_service: UserService,
    private storage: StorageService,
    private observatory: ObservatoryService
  ) { }

  ngOnInit() {
    //console.log("HEADER!!!");
    if (this.storage.get('userDataStorage')) {
      this.userData = this.storage.get('userDataStorage');
    } else {
      this.subscriptions.push(
        this.observatory.getData('userData').subscribe((data) => {
          this.userData = data;
        })
      );
    }

  }
  updateUrl(event) {
    event.target.src = './assets/images/icons/default.png';
  }
  logOut(): void {
    this.user_service.logOut();
  }

  toggleSideBar(): void {
    this.toggleMiniSideBar.emit();
    this.miniLogoVisible = !this.miniLogoVisible;
  }

  toggleMiniBar(): void {
    this.toggleMiniSideBar.emit();
  }

  /**
   * @name ngOnDestroy
   * @description Lifecycle hook
   */
  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

}
